// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceSettingsSidebar-module__Container__He5g_ {
    width: 100%;
    max-width: var(--ds-70x);
}

.WorkspaceSettingsSidebar-module__AccordionPanel__r0Uu5 {
    padding-right: 0;
    padding-left: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `WorkspaceSettingsSidebar-module__Container__He5g_`,
	"AccordionPanel": `WorkspaceSettingsSidebar-module__AccordionPanel__r0Uu5`
};
export default ___CSS_LOADER_EXPORT___;
